export default {
    getSearchResults (state) {
        console.log('====================================================================================================')
        console.log('getSearchResults', state)
        console.log('====================================================================================================')
        return state.searchResults
    },
    getSearchExpertResults (state) {
        console.log('====================================================================================================')
        console.log('getSearchExpertResults', state)
        console.log('====================================================================================================')
        return state.searchResults1
    },
    getSearchPlaylistResults (state) {
        console.log('====================================================================================================')
        console.log('getSearchPlaylistResults', state)
        console.log('====================================================================================================')
        return state.searchResults2
    }
}



// WEBPACK FOOTER //
// ./src/store/search/getters.js